export default __webpack_public_path__ + "images/0x3b0cffda9a5ab64135c227638e777ceec0c243a8.png";